import axios from "axios";

// Separate instance — NO interceptors attached
// Used ONLY for token refresh calls to prevent infinite 401 loop

const axiosRefresh = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

export default axiosRefresh;